import { CompetitionCategoryType } from "./CompetitionCategoryType.js";

export const competitionCategoryTypesWithTshirt = [
	CompetitionCategoryType.FreestyleOpen,
	CompetitionCategoryType.QuadrupedMen,
	CompetitionCategoryType.QuadrupedWomen,
	CompetitionCategoryType.Sptf1,
];
